export const female_profilePicture ="https://i.ibb.co/0h7mD0r/womancol-1.png";
export const male_profilePicture = "https://i.ibb.co/C0Q8CgK/womancol-2.png";
export const url = "https://beta-wis-uiux.web.app/";
// export const url = "http://localhost:3000/";
